module.exports = __webpack_public_path__ + "img/icon-cross.fe68d57f.svg";